module.exports = __webpack_public_path__ + "img/组 348.0a61df3d.png";